import React, { FC } from 'react';
import { Button } from 'antd';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { login } from '~/routes';

import { ResetPasswordSuccessIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';
import features from '~/featuresWithDefaults';
import BusinessRepresentative from './options/BusinessRepresentative';
import WalletUser from './options/WalletUser';

const PasswordResetSuccess: FC<RouteComponentProps> = () => {
  if (features?.successPasswordResetOptions?.enabled) return <PasswordResetWithOptions />;

  return <DefaultPasswordReset />;
};

const DefaultPasswordReset: FC = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();

  const onClick = () => {
    history.replace(`/${login}`);
  };

  return (
    <PasswordResetLayout
      icon={<ResetPasswordSuccessIcon />}
      title={t('Success!')}
      subtitle={t('Your password has been updated. Now you can log in using new password.')}
    >
      <Button type="primary" size="large" className="PasswordResetSuccess-Button" onClick={onClick}>
        {t('Log in')}
      </Button>
    </PasswordResetLayout>
  );
};

const PasswordResetWithOptions: FC = () => {
  const { t } = useTranslation('passwordReset');

  return (
    <PasswordResetLayout
      icon={<ResetPasswordSuccessIcon />}
      title={t('Success!')}
      subtitle={t(
        'Your password has been updated. Now you can select the preferred login option and log in with your new password.'
      )}
    >
      {features?.successPasswordResetOptions?.options?.map((name) => {
        switch (name) {
          case 'BusinessRepresentative':
            return <BusinessRepresentative />;
          case 'WalletUser':
            return <WalletUser />;
          default:
            return null;
        }
      })}
    </PasswordResetLayout>
  );
};

export default PasswordResetSuccess;
